@if (!item.hidden) {
  <!-- item.url -->
  @if (item.url && !item.externalUrl && !item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'mat-accent-bg']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
      [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl -->
  @if (item.url && item.externalUrl && !item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.function -->
  @if (!item.url && item.function) {
    <span [attr.data-e2e]="'nav-item-' + item.id" class="nav-link" [ngClass]="item.classes"
      (click)="item.function()" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>
  }
  <!-- item.url && item.function -->
  @if (item.url && !item.externalUrl && item.function) {
    <a [attr.data-e2e]="'nav-item-' + item.id" class="nav-link" [ngClass]="item.classes"
      (click)="item.function()"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'mat-accent-bg']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
      [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl && item.function -->
  @if (item.url && item.externalUrl && item.function) {
    <a [attr.data-e2e]="'nav-item-' + item.id" class="nav-link" [ngClass]="item.classes"
      (click)="item.function()"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <ng-template #itemContent>
    @if (item.icon) {
      <mat-icon class="nav-link-icon" svgIcon="{{item.icon}}"></mat-icon>
    }
    <span class="nav-link-title" [translate]="item.translate"></span>
    @if (item.badge) {
      <span class="nav-link-badge" [translate]="item.badge.translate"
        [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
      </span>
    }
  </ng-template>
}
